export const create = (type) => {
    return { type: type, children: [{ type: "paragraph", children: [{ text: "" }] }] }
}